import script from "./MessageVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageVideo.vue?vue&type=script&setup=true&lang=js"

import "./MessageVideo.vue?vue&type=style&index=0&id=e41308ac&scoped=true&lang=less"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e41308ac"]])

export default __exports__